export default "__VITE_ASSET__1cdd1a91__"